import React, { useState } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import PDFtoText from "react-pdftotext"; // Importera som en komponent

const DocumentScanner = () => {
  const [pdfText, setPdfText] = useState(""); // State för att lagra extraherad text
  const [fileName, setFileName] = useState(""); // State för filnamn
  const [file, setFile] = useState(null); // State för den valda filen

  // Hantera uppladdning av fil
  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  // Extrahera text från PDF
  const handleExtractText = () => {
    if (file) {
      // Använd PDFtoText för att extrahera text från PDF
      PDFtoText(file).then((text) => {
        setPdfText(text);
      });
    }
  };

  return (
    <Box sx={{ padding: 4, maxWidth: 600, margin: "auto" }}>
      <Typography variant="h4" gutterBottom>
        Document Scanner
      </Typography>

      {/* Filuppladdning */}
      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileUpload}
        style={{ display: "none" }}
        id="pdf-upload"
      />
      <label htmlFor="pdf-upload">
        <Button variant="contained" component="span">
          Upload PDF
        </Button>
      </label>

      {fileName ? (
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          File: {fileName}
        </Typography>
      ) : (
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          Please upload a PDF file
        </Typography>
      )}

      {/* Extrahera text från PDF */}
      <Button
        variant="contained"
        sx={{ marginTop: 2 }}
        onClick={handleExtractText}
        disabled={!file} // Knappen är inaktiverad om ingen fil har valts
      >
        Extract Text
      </Button>

      {/* Visa extraherad text */}
      {pdfText && (
        <Paper
          sx={{ padding: 2, marginTop: 3, maxHeight: 400, overflow: "auto" }}
          elevation={4}
        >
          <Typography variant="h6">Extracted Text:</Typography>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "pre-wrap", // Bevara radbrytningar och mellanslag
              wordBreak: "break-word", // För att förhindra ord att brytas på konstiga ställen
            }}
          >
            {pdfText}
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default DocumentScanner;
